const timeStampToDateTime = (timeStamp)=>{
    try{
        if(!timeStamp){
            throw new Error('Invalid time stamp format');
        }
        let d = new Date(timeStamp).toLocaleString();
        return d.substring(0,d.length-3).replace('/', '-');
    }catch(err){
        return '';
    }
}

const handleFilesUI = (file) => {
    if (file.picture) {
        return { withImg: true, uri: file.picture }
    }
    else {
        if (file.document_type == 'pdf' || file.document_type == "application/pdf") {
            return { withImg: false, uri: require('../assets/images/PDF_file_icon.png') }
        }
        else if (file.document_type == 'word' || file.document_type == "application/msword" || file.document_type == "application/vnd.openxmlformats-officedocument.wordprocessingml.document") {
            return { withImg: false, uri: require('../assets/images/word.png') }
        }
        else if (file.document_type == 'image' || file.document_type == "image/png" || file.document_type == 'image/jpg' || file.document_type == 'image/jpeg') {
            return { withImg: false, uri: require('../assets/images/image_icon.png') }
        }
        else if (file.document_type == 'excel' || file.document_type == "application/vnd.ms-excel" || file.document_type == "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") {
            return { withImg: false, uri: require('../assets/images/Microsoft_Office_Excel.png') }
        }
        else if (file.document_type == 'ppt' || file.document_type == "application/vnd.ms-powerpoint" || file.document_type == "application/vnd.openxmlformats-officedocument.presentationml.presentation") {
            return { withImg: false, uri: require('../assets/images/ppt.png') }
        }
        else if (file.document_type == 'text/plain' || file.document_type == "text") {
            return { withImg: false, uri: require('../assets/images/txt.png') }
        }
        else if (file.document_type == 'url') {
            return { withImg: false, uri: require('../assets/images/link.png') }
        }
        else {
            return { withImg: false, uri: require('../assets/images/unknown-file.png') }
        }
    }
}

const checkPageFormat = (str)=>{
    const strToNumber = (str)=>{
        const num = Number(str);
        if(isNaN(num)){
            throw new Error();
        }
        return num;
    }
    
    const splitStrNumber = (list)=>{
        if(list.length !== 2 || !strToNumber(list[0]) || !strToNumber(list[1])){
            throw new Error();
        }
        return [strToNumber(list[0]), strToNumber(list[1])];
    }

    const rangeToPage = ([from, to])=>{
        const list = [];
        for(let i = from; i <= to; i++){
            list.push(i);
        }
        return list;
    }

    let pages = [];
    let pageList = str.replaceAll(' ', '').split(',');
    for(let i = 0; i < pageList.length; i++){
        const ele = pageList[i];
        if(ele.indexOf('-') > -1){
            const tempList = splitStrNumber(ele.split('-'));
            pages.push(...rangeToPage(tempList));
        }else{
            pages.push(strToNumber(ele));
        }
    }
    return pages;
} 

const getSelectedDocumentIds = (docList)=>{
    const selectedDL = docList.map(ele => {
        if(ele.selected){
            return ele.document_id;
        }else{
            return false;
        }
    }).filter(x=>x);
    return selectedDL;
}

export {
    timeStampToDateTime,
    handleFilesUI,
    checkPageFormat,
    getSelectedDocumentIds
}